import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { RegionFormDialogComponent } from '@components/dialog/region-form-dialog/region-form-dialog.component';
import { MainLayoutComponent } from '@components/layout/main-layout/main-layout.component';
import { apiRouteInterceptorProvider } from '@interceptors/api-route.interceptor';
import { authInterceptorProvider } from '@interceptors/auth.interceptor';
import { responseMapperInterceptorProvider } from '@interceptors/response-mapper.interceptor';
import { AuthService } from '@services/auth.service';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [AppComponent],
  providers: [
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AuthService, NgxPermissionsService, HttpClientModule],
      useFactory: (authService: AuthService) => {
        return () => authService.getUserInfo();
      },
    },
    {
      provide: APP_BASE_HREF,
      useValue: '/market',
    },
    responseMapperInterceptorProvider,
    apiRouteInterceptorProvider,
    authInterceptorProvider,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MainLayoutComponent,
    HttpClientModule,
    NgxPermissionsModule.forRoot(),
    BrowserAnimationsModule,
    RouterModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: false,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    RegionFormDialogComponent,
  ],
})
export class AppModule {}
